import React, { createContext, useContext, useEffect, useState } from 'react';
import { buildApiUrl } from '../apiBase';

// Is this browser the owner's? The API answers on the TCP peer address alone
// (api_access.py), so the honest question is "did this page reach the API from
// the tailnet", and only the API can answer it. Asked once per app load.
//
// This is presentation only. Hiding the Portfolio nav is a courtesy to
// visitors, NOT the access control -- every owner-only route is closed at the
// origin whatever this says. A visitor who flips the flag in devtools gets a
// page full of 401s.
//
// Deliberately `fetch`, not axios: this file is imported by the Sidebar test,
// and the whole point of the value being injectable is that a test can render
// either state without a network stub.
const DEFAULT_WHOAMI = { owner: false, via: null, loading: true };

const WhoamiContext = createContext(DEFAULT_WHOAMI);

export function WhoamiProvider({ children, value }) {
  const [whoami, setWhoami] = useState(value || DEFAULT_WHOAMI);

  useEffect(() => {
    if (value) return undefined;
    let live = true;
    fetch(buildApiUrl('/whoami'), { signal: AbortSignal.timeout(10000) })
      .then((res) => (res.ok ? res.json() : { owner: false, via: null }))
      .catch(() => ({ owner: false, via: null }))
      // An unreachable API means a visitor: fail to the smaller surface.
      .then((data) => {
        if (live) setWhoami({ owner: !!data.owner, via: data.via || null, loading: false });
      });
    return () => {
      live = false;
    };
  }, [value]);

  return <WhoamiContext.Provider value={whoami}>{children}</WhoamiContext.Provider>;
}

export function useWhoami() {
  return useContext(WhoamiContext);
}

export default WhoamiContext;
